<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { RouterLink } from "vue-router";
import adminUserService from "../../../services/user/adminUserService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const loadingStore = usePageLoadingStore()
const { $gbNameKR, $yyyymmdd } = getCurrentInstance().appContext.config.globalProperties;

const lectureHistories = ref(null);

const retrieveLectHistoryList = () => {
  loadingStore.loading = true;
  adminUserService.retrieveUserLectureList(user.value.userId)
      .then( async (res) => {
        loadingStore.loading = false;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          lectureHistories.value = result;
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
  });
}

onMounted(() => {
  retrieveLectHistoryList();
})

</script>
<template>
  <div class="table-form">
    <table class="horizontal" v-if="lectureHistories !== null">
      <tr>
        <th>구분</th>
        <th>강의명</th>
        <th>상태</th>
        <th>수강 신청일</th>
        <th>교육 기간</th>
        <th>수강 취소일</th>
        <th>진도율</th>
        <th>Pass/Fail</th>
        <th>수강현황</th>
      </tr>
      <tr v-for="lectHist in lectureHistories">
        <td>{{ lectHist.lectGb === '01' ? '온라인' : '오프라인' }}</td>
        <td class="link text-left"><RouterLink :to="{name:'LectureDetail', params:{id: lectHist.lectId}}">{{ lectHist.lectName }}</RouterLink></td>
        <td>
          <span>{{ $gbNameKR('LECT_STATE_GB2', lectHist.lectStateGb)}}</span>
        </td>
        <td>{{ $yyyymmdd(lectHist.regYmd) }}</td>
        <td>
          <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span> <!-- 09: 수강 신청 취소(사용자) 10: 수강 취소(Admin) -->
          <span v-else-if="lectHist.lectTermGb === '01'">신청일로부터 {{lectHist.lectTerm}}일</span>
          <span v-else-if="true">{{ $yyyymmdd(lectHist.lectStartYmd)}} ~ {{ $yyyymmdd(lectHist.lectEndYmd) }}</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">{{ $yyyymmdd(lectHist.cancelDt) }}</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span>
          <span v-else>{{ lectHist.lectureIndexFinishCount }}/{{ lectHist.lectureIndexCount }}({{ lectHist.progRate }}%)</span>
        </td>
        <td>
          <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span>
          <span v-else-if="lectHist.finYn">{{ lectHist.finYn === 'Y' ? 'Pass'
              : lectHist.finYn === 'N' ? 'Fail'
                  : lectHist.finYn === 'D' ? '평가전'
                      : '-' }}</span>
          <span v-else>-</span>
        </td>
        <td :class="{'wait': (lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10'), 'complete': (lectHist.lectStateGb !== '09' && lectHist.lectStateGb !== '10')}">
          <KSATextButton v-if="(lectHist.lectStateGb !== '09' && lectHist.lectStateGb !== '10')" text="수강현황" @click="goLectureCourseDetail(lectHist.lectId)" />
          <span v-else>수강현황</span>
        </td>
      </tr>
    </table>
    <div class="result-none" v-if="lectureHistories === null || lectureHistories.length === 0">
      수강 내역이 없습니다.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>